import React from 'react'

function CountryIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.33333 5L14.6667 6.75M9.33333 5L4 6.75V19L9.33333 17.25M9.33333 5V17.25M14.6667 6.75V19M14.6667 6.75L20 5V17.25L14.6667 19M14.6667 19L9.33333 17.25"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CountryIcon